import Cache from "../Util/Cache.js";
import {cof2Obj} from "../lib/geomagJS/cof2Obj.js";
import {geoMagFactory} from "../lib/geomagJS/geomag.js";

export type GeoMagResponse = {
    dec: number,
    dip: number,
    ti: number,
    bh: number,
    bx: number,
    by: number,
    bz: number,
    lat: number,
    lon: number,
    gv: number,
    epoch: number,
};

type GeoMagFactory = (glat: number, glon: number, h_feet: number, date: Date) => GeoMagResponse;

export default class MagneticNorthProvider {
    private static readonly WMM_FILE_PATH = 'data/NCEI/WMM2025.COF';
    private readonly factoryPromise: Promise<void>;
    private geoMagFactory: GeoMagFactory|null = null;

    constructor(private readonly cache: Cache) {
        this.factoryPromise = this.buildGeoMagFactory();
    }

    private async getWmmContents() {
        return await this.cache.fetch(MagneticNorthProvider.WMM_FILE_PATH, async () => {
            const response = await fetch(MagneticNorthProvider.WMM_FILE_PATH);
            return response.text();
        });
    }

    private async buildGeoMagFactory() {
        const wmm = cof2Obj(await this.getWmmContents());
        this.geoMagFactory = geoMagFactory(wmm);
    }

    public async awaitInit() {
        return this.factoryPromise;
    }

    public retrieve(lon: number, lat: number): GeoMagResponse {
        return this.geoMagFactory(lat, lon);
    }
}
